export default {
  ATTACHMENTS_MODAL: {
    TITLE: `Attachments`,
    SUMMARY: ``
  },
  NO_ATTACHMENTS: `No attachments`
}
